// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer components {
	thead th button.cursor-pointer {
		margin: -2px -6px;
		padding: 2px 6px;
		border: 1px solid transparent;
		border-radius: var(--radius-md);
		background-color: transparent;
	}

	thead th:hover button.cursor-pointer,
	thead th button.cursor-pointer:hover,
	thead th button.cursor-pointer:focus-visible {
		border-color: var(--color-border-control);
		background-color: var(--color-surface);
		color: var(--color-text);
	}

	thead th[aria-sort] button.cursor-pointer {
		border-color: var(--color-border-control);
		background-color: var(--color-surface);
		color: var(--color-text);
	}

	thead th button.cursor-pointer,
	thead th span.truncate {
		text-transform: none;
	}
}

/* Unlayered rules override utility styles. */
thead th button.cursor-pointer {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

thead th[aria-sort] button.cursor-pointer {
	position: relative;
	padding-right: 24px;
}

thead th[aria-sort] button.cursor-pointer svg {
	position: absolute;
	top: 50%;
	right: 6px;
	transform: translateY(-50%);
}

div:has(> [data-column-id]) {
	display: grid;
	grid-auto-flow: column;
	grid-template-rows: repeat(10, auto);
	grid-auto-columns: minmax(10rem, max-content);
	column-gap: 1rem;
	overflow-x: auto;
	overscroll-behavior: contain;
}

@media (max-width: 45rem) {
	div:has(> [data-column-id]) {
		grid-template-rows: repeat(13, auto);
	}
}

[role='dialog']:has(> div > div > [data-column-id]) {
	width: max-content;
	min-width: min(16rem, calc(100vw - 3rem));
	max-width: calc(100vw - 3rem);
	margin-right: 1.5rem;
	max-height: calc(var(--radix-popper-available-height) - 1.5rem);
	overflow-y: auto;
}

/* Translate after placement without changing the measured popover bounds. */
[role='dialog'][data-align='end']:has(> div > div > [data-column-id]) {
	translate: 1.5rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/web/theme/flyt-overrides.css"],"names":[],"mappings":"AAAA;CACC;EACC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;CAC9B;;CAEA;;;EAGC,yCAAyC;EACzC,sCAAsC;EACtC,wBAAwB;CACzB;;CAEA;EACC,yCAAyC;EACzC,sCAAsC;EACtC,wBAAwB;CACzB;;CAEA;;EAEC,oBAAoB;CACrB;AACD;;AAEA,6CAA6C;AAC7C;CACC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,oCAAoC;CACpC,6CAA6C;CAC7C,gBAAgB;CAChB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC;EACC,oCAAoC;CACrC;AACD;;AAEA;CACC,kBAAkB;CAClB,yCAAyC;CACzC,6BAA6B;CAC7B,oBAAoB;CACpB,+DAA+D;CAC/D,gBAAgB;AACjB;;AAEA,4EAA4E;AAC5E;CACC,mBAAmB;AACpB","sourcesContent":["@layer components {\n\tthead th button.cursor-pointer {\n\t\tmargin: -2px -6px;\n\t\tpadding: 2px 6px;\n\t\tborder: 1px solid transparent;\n\t\tborder-radius: var(--radius-md);\n\t\tbackground-color: transparent;\n\t}\n\n\tthead th:hover button.cursor-pointer,\n\tthead th button.cursor-pointer:hover,\n\tthead th button.cursor-pointer:focus-visible {\n\t\tborder-color: var(--color-border-control);\n\t\tbackground-color: var(--color-surface);\n\t\tcolor: var(--color-text);\n\t}\n\n\tthead th[aria-sort] button.cursor-pointer {\n\t\tborder-color: var(--color-border-control);\n\t\tbackground-color: var(--color-surface);\n\t\tcolor: var(--color-text);\n\t}\n\n\tthead th button.cursor-pointer,\n\tthead th span.truncate {\n\t\ttext-transform: none;\n\t}\n}\n\n/* Unlayered rules override utility styles. */\nthead th button.cursor-pointer {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\nthead th[aria-sort] button.cursor-pointer {\n\tposition: relative;\n\tpadding-right: 24px;\n}\n\nthead th[aria-sort] button.cursor-pointer svg {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 6px;\n\ttransform: translateY(-50%);\n}\n\ndiv:has(> [data-column-id]) {\n\tdisplay: grid;\n\tgrid-auto-flow: column;\n\tgrid-template-rows: repeat(10, auto);\n\tgrid-auto-columns: minmax(10rem, max-content);\n\tcolumn-gap: 1rem;\n\toverflow-x: auto;\n\toverscroll-behavior: contain;\n}\n\n@media (max-width: 45rem) {\n\tdiv:has(> [data-column-id]) {\n\t\tgrid-template-rows: repeat(13, auto);\n\t}\n}\n\n[role='dialog']:has(> div > div > [data-column-id]) {\n\twidth: max-content;\n\tmin-width: min(16rem, calc(100vw - 3rem));\n\tmax-width: calc(100vw - 3rem);\n\tmargin-right: 1.5rem;\n\tmax-height: calc(var(--radix-popper-available-height) - 1.5rem);\n\toverflow-y: auto;\n}\n\n/* Translate after placement without changing the measured popover bounds. */\n[role='dialog'][data-align='end']:has(> div > div > [data-column-id]) {\n\ttranslate: 1.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
